import wopr from '../assets/projects/wopr1.webp';
import idleveil from '../assets/projects/idleveil2.webp';
import magisterT from '../assets/projects/MagisterT.webp';
import svartso from '../assets/projects/svartso.webp';
import mandatum from '../assets/projects/mandatum3.webp';

export const projects = [
  {
    id: 'wopr',
    title: 'WOPR',
    description: 'Retro-styled AI desktop assistant with multi-provider support and voice activation.',
    image: wopr,
    tags: ['Tauri', 'SvelteKit', 'AI'],
    link: '/products/wopr',
    featured: true,
    status: 'released'
  },
  {
    id: 'mandatum',
    title: 'Mandatum',
    description: 'Prompt engineering platform with custom code execution. Live and in alpha.',
    image: mandatum,
    tags: ['React', 'FastAPI', 'AI'],
    link: '/products/mandatum',
    featured: true,
    status: 'alpha'
  },
  {
    id: 'idleveil',
    title: 'Idleveil',
    description: 'Hardcore text RPG with permadeath. Live and in alpha. Angular 20 + .NET 8.',
    image: idleveil,
    tags: ['Angular', '.NET', 'PostgreSQL'],
    link: '/products/idleveil',
    featured: true,
    status: 'alpha'
  },
  {
    id: 'magister-t',
    title: 'Magister T',
    description: 'Educational platform for interactive learning experiences.',
    image: magisterT,
    tags: ['React', 'Node.js', 'Education'],
    externalLink: 'https://github.com/Ivargavve',
    featured: true,
    status: 'completed'
  },
  {
    id: 'svartso',
    title: 'Svartsö',
    description: 'Website and booking system for Svartsö island services.',
    image: svartso,
    tags: ['Web', 'Booking', 'Tourism'],
    externalLink: 'https://svartso.se',
    featured: true,
    status: 'completed'
  }
];

export const getFeaturedProjects = () => projects.filter(p => p.featured);
export const getProjectById = (id) => projects.find(p => p.id === id);
export const getProjectsByStatus = (status) => projects.filter(p => p.status === status);
